<template>
  <div class="tongyongdl" style="min-height:700px;margin-bottom:3px">
      <div class="xuexijieshao" v-for="(item,index) in sp" :key="index">
          <div  class="jieshaoheadlf" @click="showif(index)">培训视频：{{item.title}}</div>
          <div class="sp_box">
            <div v-for="(item1,index1) in item.text" :key="index1" @click="clicktjnew(item.mp4[index1],item1)" class="sp_item">
                    <img src="../../../../assets/images/视频.svg" alt="" class="sp_svg"><div class="sp_text">{{item1}}</div>
            </div>
          </div>
       
      </div>
  </div>
</template>

<script>
import axios from "axios";
import vcd from "./vcd.vue"
export default {
data(){
    return{
        ts:'',
        kg:'',
        sp:[{title:'',
        show:false,
        dl:0,
        see:0,
        dltj:15,
        seetj:14,  
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E9%AB%98%E7%BA%A7%E6%8A%80%E6%9C%AF%E5%88%86%E6%9E%90%E6%8A%80%E5%B7%A7%E8%A7%A3%E6%9E%90ppt.rar',
        text:['扩展分析工具','基于线性回归方程的价格走势判断方法  ','探寻商品波动率及周期性变化规律','基本面于技术面结合的远期链分析',
        '云端选股公式的编写及使用方法','云端形态选股的使用方法','云端公式预警、趋势线预警使用方法'],
        mp4:[
            '3c738622-19f02ee48d7/3c738622-19f02ee48d7.mp4',
            '3a20281-19f02ee48d8/3a20281-19f02ee48d8.mp4',
            '423c0ad8-19f02ee48e6/423c0ad8-19f02ee48e6.mp4',
            '284e3ae0-19f02ee48d9/284e3ae0-19f02ee48d9.mp4',
            '218d7e65-19f02ee48ea/218d7e65-19f02ee48ea.mp4',
            '417dc088-19f02ee48df/417dc088-19f02ee48df.mp4',
            '32f4fd93-19f02ee4ac6/32f4fd93-19f02ee4ac6.mp4',
            // 'wh7高级技术分析技巧解析/1扩展分析工具.mp4',
        ]

        },{title:'如何提高套利收益',
        show:false,
        dl:0,
        see:0,
        dltj:17,
        seetj:16, 
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E5%A6%82%E4%BD%95%E6%8F%90%E5%A5%97%E5%88%A9%E6%94%B6%E7%9B%8Appt.rar',
        text:['什么是套利','套利的优势','期货套利交易类型','套利交易的注意事项','跨期套利-如何避免瘸腿','跨品种套利-如何配比手数','跨市场套利-如何精确配比'],
        mp4:[
            '406bf735-19f02f0496b/406bf735-19f02f0496b.mp4',
            '25481f24-19f02f0495d/25481f24-19f02f0495d.mp4',
            '43253f64-19f02f04959/43253f64-19f02f04959.mp4',
            '332c6f2e-19f02f0495a/332c6f2e-19f02f0495a.mp4',
            '330164aa-19f02f0495a/330164aa-19f02f0495a.mp4',
            '5fc6e322-19f02f04956/5fc6e322-19f02f04956.mp4',
            '5c35bb80-19f02f04b84/5c35bb80-19f02f04b84.mp4',
            // 'wh7高级技术分析技巧解析/1扩展分析工具.mp4',
        ]
       },{title:'',
        show:false,
        dl:0,
        see:0,
        dltj:21,
        seetj:20, 
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E5%A6%82%E4%BD%95%E6%8F%90%E5%A5%97%E5%88%A9%E6%94%B6%E7%9B%8Appt.rar',
        text:['下单任务管理器','算法交易','网格交易运行池','文件下单','多账号管理'],
       mp4:[
            '23f1985c-19f02ebfd00/23f1985c-19f02ebfd00.mp4',
            '52f07ca7-19f02ebfd14/52f07ca7-19f02ebfd14.mp4',
            '67b3de0c-19f02ebfcfe/67b3de0c-19f02ebfcfe.mp4',
            '48cd8fc9-19f02ebfcf5/48cd8fc9-19f02ebfcf5.mp4',
            '44b60864-19f02ebfd14/44b60864-19f02ebfd14.mp4',
            // 'wh7高级技术分析技巧解析/1扩展分析工具.mp4',
        ]
       },
       {title:'',
        show:false,
        dl:0,
        see:0,
        dltj:25,
        seetj:24, 
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E5%A6%82%E4%BD%95%E6%8F%90%E5%A5%97%E5%88%A9%E6%94%B6%E7%9B%8Appt.rar',
        text:['什么是统计套利','专业的套利历史数据 ','套利扩展分析工具','套利下单工具','套利算法交易辅助'],
         mp4:[
            '30f94156-19f02f14d3c/30f94156-19f02f14d3c.mp4',
            '5318f311-19f02f14d39/5318f311-19f02f14d39.mp4',
            '1aa271ca-19f02f14d46/1aa271ca-19f02f14d46.mp4',
            '3228815c-19f02f14d3f/3228815c-19f02f14d3f.mp4',
            '37e2ebc9-19f02f14d44/37e2ebc9-19f02f14d44.mp4',
            // 'wh7高级技术分析技巧解析/1扩展分析工具.mp4',
        ]
       }]
    }
},
methods:{
showif(id){
    this.sp[id].show=!this.sp[id].show
},
clicktj(el){
//     axios.get("dl.asp?mod=dl&id="+ el +"").then((res)=>{
// this.ts=res
//   }).catch((err)=>{console.log(err);})
  window.location.href="/dl.asp?mod=dl&id="+ el +""
// window.open(lj, "_blank");
},
clicktjnew(lj,item){
// var mask_bg = document.createElement("div");
//     mask_bg.id = "mask_bg";
//     mask_bg.style.position = "fixed";
//     mask_bg.style.top = "0px";
//     mask_bg.style.left = "0px";
//     mask_bg.style.width = "100%";
//     mask_bg.style.height = "100%";
//     mask_bg.style.backgroundColor = "rgba(0,0,0,0.6)";
//     // mask_bg.style.opacity = 0.6;
//     mask_bg.style.zIndex = 1111111;
//     document.body.appendChild(mask_bg);
//     var alertcont =document.createElement('div');
    
//     alertcont.style.width='1000px'
//     alertcont.style.height='600px'
//     alertcont.style.position='fixed'
//     alertcont.style.background='black'
//     alertcont.style.left='20%'
//     alertcont.style.top='20%'
//     alertcont.style.zIndex = 111111111;
//     mask_bg.appendChild(alertcont);
//     var alertcont2=document.createElement('div');
//     alertcont2.style.position='relative'
//     alertcont2.style.width='100%'
//     alertcont2.style.height='100%'
//     alertcont.appendChild(alertcont2);
//     var bao=document.createElement('iframe');
//     bao.src="/dl.asp?mod=dl&id="+ lj +""
//     bao.style.width='100%'
//     bao.style.height='100%'
//     alertcont2.appendChild(bao);
//     var chabox =document.createElement('div');
//     chabox.innerHTML='x'
//     chabox.style.color='white'
//     chabox.style.position='absolute'
//     chabox.style.right='-5px'
//     chabox.style.top='0'
//     chabox.style.width='15px'
//     chabox.style.height='15px'
//     chabox.style.cursor='pointer'
//     chabox.onclick=function(){
//         var mask_bg = document.getElementById("mask_bg");
//     if (mask_bg != null)
//         mask_bg.parentNode.removeChild(mask_bg);
//     }
//     alertcont2.appendChild(chabox);

let target=this.$root.$frame.box(vcd,{
    unvariable:false,
    width:'1000px',
    height:'600px',
    props:{
        src:'https://video-ali-sh.wenhua.com.cn/sv/'+lj
    }
})
  axios.get("https://rich.wenhua.com.cn/dl.asp?mod=dl&source=wh7&name="+ item +"&url=https://video-ali-sh.wenhua.com.cn/sv/"+lj).then((res)=>{
    console.log(res)
  })
},
// setSP(){
//     let vm = this;
//     let obj = vm.$store.state.commonDataObj;
//     if(obj) {
//         vm.sp[0].title = obj['appShortName_12'] + '高级技术分析技巧解析';
//         vm.sp[2].title = obj['appShortName_12'] + '机构交易工具';
//         vm.sp[3].title = '用' + obj['appShortName_12'] + '软件做期货套利交易';
//     }
// }
},
watch: {
    '$store.state.commonDataObj': {
        handler(newValue){
            this.sp[0].title = newValue['appShortName_12'] + '高级技术分析技巧解析';
            this.sp[2].title = newValue['appShortName_12'] + '机构交易工具';
            this.sp[3].title = '用' + newValue['appShortName_12'] + '软件做期货套利交易';
        },
        immediate: true,
        deep: true
    }
},
created(){
    // this.setSP()
//     var data=[14,15,16,17,20,21,24,25]
//     data.forEach((el,idx)=>{
// axios.get("dl.asp?mod=cat&id="+ el +"").then((res)=>{
// var cont=Math.floor( idx/2 )   

// if(idx%2==0){
// this.sp[cont].see=res.data
// }
// else{
//     this.sp[cont].dl=res.data
// }
//   }).catch((err)=>{console.log(err);})
//     })
    

  }


}
</script>

<style scoped>
.zhedang{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: black;
    opacity: 0.6;
    z-index: 55555555;
    /* display: none; */
}
.xz span{
    display: inline-block;
    margin-left: 10px;
    font-size: 13px;
    color: #8b8c8c;
}
.shipin{
    background: url("../../../../assets/images/bof.png") no-repeat 15px center;
    background-color: #364064;
    height: 30px;
    color: white;
    line-height: 30px;
    padding-left: 35px;
    width: 75px;
    margin: 20px 0;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-size: 15px;
}
.ppt{
   background: url("../../../../assets/images/xiaz.png") no-repeat 15px center;
    background-color: #c4954d;
    height: 30px;
    color: white;
    line-height: 30px;
    padding-left: 35px;
    width: 100px;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-size: 15px;
}
.play{
    display: block;
}
.textt{
    width: 330px;
    display: inline-block;
    color: #8b8c8c;
    padding: 10px 0;
    font-size: 14px;
}
.playnone{
    display: none;
}
.xuexijieshao{
    width: 920px;
    margin: 0 auto;
    padding: 45px 0;
    border-bottom:1px gray dashed ;
    padding-bottom: 30px;
}
.xuexijieshao:last-child{
    border: none;
}
.jieshaoheadlf{
    color: rgb(39, 84, 121);
    font-size: 15px;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
}
.sp_svg {
    width: 14px;
    height: 14px;
    margin-right: 7px;
}
.sp_item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 34px;
    line-height: 34px;
    width: 50%;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
}
.sp_box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 800px;
    margin-top: 20px;
}
.sp_text {
    color: #6787a9;
}
</style>